export const GET_RECOGNITION_DATA = 'get-recognition-data';
export const GET_BONUS_DATA = 'get-bonus-data';
export const GET_PULSE_DATA = 'get-pulse-data';
export const GET_GIF_LIST = 'get-gif-list';
export const GET_SUGGESTION_BOX_DATA = 'get-suggestion-box-data';
export const GET_REQUESt_FEEDBACK_DATA = 'get-request-feedback-data';
export const GET_SEND_FEEDBACK_DATA = 'get-send-feedback-data';
export const GET_WORKSPACE_CONFIG = 'get-workspace-config';
export const GET_INTROS_CONFIG = 'get-intros-config';
export const GET_WORKSPACE_PROFILE = 'get-workspace-profile';
